import React from 'react';
import StreetView from 'app/client/google/StreetView';
import type { ListingDetails } from 'app/types/listingDetails.type';

interface StreetViewComponentProps {
  listing: ListingDetails;
}

const StreetViewComponent = React.memo(({ listing }: StreetViewComponentProps) => {
  return <StreetView lat={listing.geo.lat} lng={listing.geo.lon} />;
});

StreetViewComponent.displayName = 'StreetViewComponent';

export default StreetViewComponent;
